import {
  LOADED_ALL_COOPERATIVAS_ACTION,
  LOADED_CIDADES_ACTION,
  LOADED_COOPERATIVAS_ACTION,
  LOADED_ESTADOS_ACTION,
  LOADED_CENTRAIS_ACTION,
  LOADING_ALL_COOPERATIVAS_ACTION,
  LOADING_CIDADES_ACTION,
  LOADING_COOPERATIVAS_ACTION,
  LOADING_ESTADOS_ACTION,
  LOADING_ALL_CENTRAIS_ACTION,
  RESETED_LOGRADOURO,
  LOADED_COOPS_CENTRAL_ACTION,
  LOADING_COOPS_CENTRAL_ACTION,
  LOADING_ALL_ESTADOS_BY_COOPS_ACTION,
  LOADED_ALL_ESTADOS_BY_COOPS_ACTION,
  LOADING_COOPS_CENTRAL_STATE_ACTION,
  LOADED_COOPS_CENTRAL_STATE_ACTION,
  LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
  LOADED_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL,
  LOADED_ALL_CIDADES_BY_LIST_ESTADO_ID,
  LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID,
} from './LogradouroActions';
import {
  ARRAY_UTILS_SORT_ASC,
  getOrderedByObjectStringProperty,
} from '../../utils/ArrayUtils';
import { LogradouroAction, LogradouroState } from './LogradouroTypes';

const INITIAL_STATE = {
  estados: [],
  loadingEstados: false,

  cidades: [],
  loadingCidades: false,

  cooperativas: [],
  loadingCooperativas: false,

  allCooperativas: [],
  loadingAllCooperativas: false,

  allCentrais: [],
  loadingCentrais: false,

  allCoopsByCentral: [],
  loadingCoopsCentral: false,

  allEstadosByCoops: [],
  loadingAllEstadosByCoops: false,

  allStateCoopsCentral: [],
  loadingAllStateCoopsCental: false,

  allEstadosAndCoopsByCentral: {},
  loadingEstadosAndCoopsByCentral: false,

  allCidadesByListEstado: [],
  loadingAllCidadesByListEstado: false,
};

export default function LogradouroReducer(state: LogradouroState = INITIAL_STATE, action: LogradouroAction) {
  switch (action.type) {
    case RESETED_LOGRADOURO:
      return {
        ...INITIAL_STATE,
      };
    case LOADED_COOPERATIVAS_ACTION:
      return {
        ...state,
        cooperativas: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADING_COOPERATIVAS_ACTION:
      return { ...state, loadingCooperativas: action.payload };
    case LOADED_ALL_COOPERATIVAS_ACTION:
      return {
        ...state,
        allCooperativas: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADING_ALL_COOPERATIVAS_ACTION:
      return { ...state, loadingAllCooperativas: action.payload };
    case LOADING_ESTADOS_ACTION:
      return { ...state, loadingEstados: action.payload };
    case LOADING_ALL_CENTRAIS_ACTION:
      return { ...state, loadingAllCooperativas: action.payload };
    case LOADING_ALL_ESTADOS_BY_COOPS_ACTION:
      return { ...state, loadingAllEstadosByCoops: action.payload };
    case LOADED_ESTADOS_ACTION:
      return {
        ...state,
        estados: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADING_CIDADES_ACTION:
      return { ...state, loadingCidades: action.payload };
    case LOADING_COOPS_CENTRAL_ACTION:
      return { ...state, loadingCoopsCentral: action.payload };
    case LOADING_COOPS_CENTRAL_STATE_ACTION:
      return { ...state, loadingAllStateCoopsCental: action.payload };
    case LOADING_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL:
      return { ...state, loadingEstadosAndCoopsByCentral: action.payload };
    case LOADING_ALL_CIDADES_BY_LIST_ESTADO_ID:
      return { ...state, loadingAllCidadesByListEstado: action.payload };
    case LOADED_CIDADES_ACTION:
      return {
        ...state,
        cidades: {
          ...state.cidades,
          [String(action.payload.uf).toLowerCase()]:
          getOrderedByObjectStringProperty(
            action.payload.cidades,
            'nome',
            ARRAY_UTILS_SORT_ASC
          ),
        },
      };
    case LOADED_CENTRAIS_ACTION:
      return {
        ...state,
        allCentrais: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_COOPS_CENTRAL_ACTION:
      return {
        ...state,
        allCoopsByCentral: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ALL_ESTADOS_BY_COOPS_ACTION:
      return {
        ...state,
        allEstadosByCoops: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_COOPS_CENTRAL_STATE_ACTION:
      return {
        ...state,
        allStateCoopsCentral: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ALL_ESTADOS_AND_COOPS_BY_IDCENTRAL:
      return {
        ...state,
        allEstadosByCoops: getOrderedByObjectStringProperty(
          action.payload.estados,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
        allCoopsByCentral: getOrderedByObjectStringProperty(
          action.payload.coops,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ALL_CIDADES_BY_LIST_ESTADO_ID:
      return {
        ...state,
        allCidadesByListEstado: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    default:
      return state;
  }
}
